import { render, staticRenderFns } from "./Block3Item.vue?vue&type=template&id=2957add5&scoped=true&"
import script from "./Block3Item.vue?vue&type=script&lang=js&"
export * from "./Block3Item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2957add5",
  null
  
)

export default component.exports